import { REPORT_TYPES, GRAPH_TYPES } from "../../../../constants/app-constant";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../../Dashboard/data_formatter/format-utils";

export const formatSovRankingSocial = (
  d,
  isLineGraph,
  graph_type,
  report_type
) => {
  try {
    let graph_data = d.graph_data;
    const postCounts = graph_data.map((d) => d.post_count);
    const color = getRandomUniqueColor(postCounts.length);
    // if (graph_type === GRAPH_TYPES.PIE) {
    //   const labels = graph_data.map((d) => d.topic_name);
    //   const datasets = [
    //     {
    //       data: postCounts,
    //       backgroundColor: color,
    //       borderColor: color,
    //       borderWidth: 0,
    //       barThickness: "flex",
    //       fill: graph_type === GRAPH_TYPES.AREA ? "start" : false,
    //       lineTension: 0,
    //     },
    //   ];
    //   return {
    //     datasets,
    //     labels,
    //   };
    // }
    if (graph_type === GRAPH_TYPES.GENDER) {
      return {
        mValue: 40,
        fValue: 60,
      };
    }
    const graphColors = getRandomUniqueColor(1);
    let labels = [];
    let BGcolors = [];
    let tempData = [];
    let hcPieChartData = [];
    graph_data && graph_data.sort((a, b) => b.post_count - a.post_count);

    graph_data.forEach((elm, index) => {
      labels.push(elm["topic_name"]);
      BGcolors.push(graphColors[index]);
      tempData.push(elm["post_count"]);
      hcPieChartData.push({
        name: elm["topic_name"],
        y: parseInt(elm["post_count"]),
        backgroundColor: graphColors[index],
      });
    });

    const datasets = [
      {
        label: "Ranking",
        backgroundColor: BGcolors[0],
        borderColor: BGcolors,
        borderWidth: 1,
        data: tempData,
        barThickness: "flex",
        fill: graph_type === GRAPH_TYPES.AREA ? "start" : false,
        lineTension: 0,
      },
    ];

    return {
      datasets,
      labels: isLineGraph ? getLineGraphFormat(labels, true) : labels,
      hcPieChartData,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
      hcPieChartData: [{}],
    };
  }
};
